$(function() {
    initFunctions();
});

function initFunctions() {
    watchInputMinus();
}

function watchInputMinus() {
    let inputFields = $('.quicksearchamountinput');

    if (!inputFields[0])
        return;

    inputFields.on('change', function() {
        let c = $(this);
        if (c.val() < 1)
            c.val(1);
    });
}